import { environment } from '@env/environment';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { platformBrowser } from '@angular/platform-browser';

import { DocsModule } from './app/docs.module';
import { brandedFavicon } from '@shared/utilities/branding.utilities';
import { fireProviders } from '../../../src/app/core/fire.providers';

if (environment.production) {
  enableProdMode();
  brandedFavicon();
}

platformBrowser().bootstrapModule(DocsModule, {
  applicationProviders: [provideZoneChangeDetection(), ...fireProviders],
});
